<template>
  <div class="sm-group-forwarding__package">
    <h5>Packaging</h5>
    <div class="sm-group-forwarding__package-main">
      <div 
        v-if="service && service.packages && service.packages.length"
        class="sm-group-forwarding__package-main-radio"
      >
        <radiobutton-block 
          :text="`Predefined package`" 
          :name="`packaging`" 
          :checked="isPredefined"
          @input="isPredefined = true" 
        />
        <radiobutton-block 
          :text="`Custom`" 
          :name="`packaging`" 
          :checked="!isPredefined"
          @input="isPredefined = false" 
        />
      </div>
      <div class="sm-group-forwarding__package-main-params">
        <template v-if="isPredefined && service && service.packages && service.packages.length">
          <label>
            <span class="sm-small">Packages</span>
          </label>
          <dropdown-block 
            class="sm-dropdown scroll-y"
            v-model="selectedPackage" 
            :options="service.packages"
            :multiple="false"
            :searchable="false"
            :allow-empty="false"
            :close-on-select="true"
            :preselect-first="true"
            :placeholder="'Select type'"
          >
            <template slot="singleLabel" slot-scope="props">
              <span>
                {{ props.option }}
              </span>
              <include-svg :name="'icon-arrow-b'" />
            </template>
            <template slot="option" slot-scope="props">
              <span>
                {{ props.option }}
              </span>
            </template>
          </dropdown-block>
        </template>
        <template v-else>
          <div class="sm-group-forwarding__package-main-params-flex">
            <input-number
              v-model="height"
              :label="'Height (inch)'"
              :min="1"
            />
            <input-number
              v-model="width"
              :label="'Width (inch)'"
              :min="1"
            />
            <input-number
              v-model="length"
              :label="'Length (inch)'"
              :min="1"
            />
          </div>
        </template>
        <div class="sm-group-forwarding__package-main-params-weight">
          <dropdown-wrap
            v-model="selectedWeightUnit"
            :val="selectedWeightUnit"
            :options="weightUnits"
            :capitalize="true"
            :label="'Weight'"
            @input="weight_unit = selectedWeightUnit.code"
          />
          <input-number
            v-model="weight"
            :defaultVal="item.weight || 0"
            :placeholder="'0'"
            :showControls="false"
            :min="1"
          />
        </div>
        <span 
          v-if="selectedWeightUnit && selectedWeightUnit.code != 'oz'"
          class="sm-tiny disabled"
        >*Package weight will be converted to ounces (OZ)</span>
      </div>
    </div>
  </div>
</template>

<script>
import PackageTypes from '@/settings/package-types';
import WeightUnits from '@/settings/weight-units';
import Radiobutton from '@/components/Radiobutton';
import Multiselect from 'vue-multiselect';
import DropdownWrap from '@/components/DropdownWrap';
import InputNumber from '@/components/InputNumber';

export default {
  name: 'mail-forwarding-packaging',
  components: {
    'radiobutton-block': Radiobutton,
    'dropdown-block': Multiselect,
    'dropdown-wrap': DropdownWrap,
    'input-number': InputNumber,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPredefined: true,
      selectedPackage: null,
      selectedWeightUnit: null,
      weightUnits: [],
      height: 1,
      width: 1,
      length: 1,
      weight: 0,
      weight_unit: ''
    }
  },
  computed: {
    weightOZ() {
      if (this.weight_unit == 'lb')
        return this.weight * 16;

      if (this.weight_unit == 'kg')
        return parseInt(this.weight * 35.274);

      if (this.weight_unit == 'g')
        return parseInt(this.weight * 0.035274) || 1;

      return this.weight;
    },
    predefinedPackage() {
      return {
        packageType: 'predefined',
        predefined: PackageTypes[this.service.id].find(item => item.label == this.selectedPackage)
      }
    },
    customPackage() {
      return {
        packageType: 'custom',
        height: this.height,
        width: this.width,
        length: this.length
      }
    },
    package() {
      let basePackage = (this.isPredefined && this.service && this.service.packages && this.service.packages.length) ? this.predefinedPackage : this.customPackage;

      return {
        toSend: {
          ...basePackage,
          weight: this.weightOZ,
          carrier_id: this.service.id
        },
        weight: this.weight,
        weight_unit: this.weight_unit
      }
    }
  },
  created() {
    this.weightUnits = WeightUnits;
    this.selectedWeightUnit = this.weightUnits.find(unit => unit.code == this.item.weight_unit) || this.weightUnits[0];
    this.weight = this.item.weight;
    this.weight_unit = this.item.weight_unit;
  },
  watch: {
    service(val) {
      if (val && val.packages && val.packages.length)
        this.selectedPackage = PackageTypes[val.id][0].label;
    },
    package: {
      deep: true,
      handler(val) {
        this.$emit('package', val);
      }
    }
  }
}
</script>